var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RoleList, userInformation } from '@src/app/helper';
import { useTalentJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { useCities, useCouriers } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { useProductCategory } from '@src/app/pages/ProductCategoryPage/ProductCategoryHooks/ProductCategory.hooks';
import { SendProductContext } from '@src/app/pages/SendProductPage/SendProduct/SendProduct';
import { useTalents } from '@src/app/pages/TalentPage/TalentHooks/Talent.hooks';
import { useTalentAddresses } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
import { defaultOptionAddress } from '@src/components/molecules/Job/Job.constant';
import ProductForm from '@src/components/molecules/SendProduct/Form/ProductForm';
import { Fragment, memo, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import FileFormik from '../../Formik/Input/FileFormik';
import InputFormik from '../../Formik/Input/InputFormik';
import MultiSelectFormik from '../../Formik/MultiSelect/MultiSelectFormik';
import TextAreaFormik from '../../Formik/TextArea/TextAreaFormik';
var SendProductForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var useForm = _a.useForm, idForEdit = _a.idForEdit, editableValue = _a.editableValue, setEditableValue = _a.setEditableValue;
    var currentData = useContext(SendProductContext);
    var role = JSON.parse(userInformation).roles[0];
    var location = useLocation();
    var _k = useState(undefined), editId = _k[0], setEditId = _k[1];
    var _l = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: '["isBlacklisted","false"]',
    }), filter = _l[0], setFilter = _l[1];
    var _m = useState(), selectedTalent = _m[0], setSelectedTalent = _m[1];
    var debouncedKeyword = useDebounce(filter.keyword, 1000)[0];
    var talents = useTalents(__assign(__assign({}, filter), { keyword: debouncedKeyword.trim() }), { enabled: !!debouncedKeyword }).talents;
    var _o = useState([]), cachedTalentsData = _o[0], setCachedTalentsData = _o[1];
    useEffect(function () {
        if (talents === null || talents === void 0 ? void 0 : talents.data)
            setCachedTalentsData(talents.data);
    }, [talents === null || talents === void 0 ? void 0 : talents.data]);
    var addresses = useTalentAddresses((selectedTalent === null || selectedTalent === void 0 ? void 0 : selectedTalent.value) || '', {
        isAllStatus: true,
    }).addresses;
    var couriers = useCouriers().couriers;
    var productCategory = useProductCategory().productCategory;
    var _p = useState(), selectedJob = _p[0], setSelectedJob = _p[1];
    var _q = useState(), selectedTeam = _q[0], setSelectedTeam = _q[1];
    var _r = useState([]), selectedAddress = _r[0], setSelectedAddress = _r[1];
    var _s = useState([]), selectedCourier = _s[0], setSelectedCourier = _s[1];
    var _t = useState([]), selectedCategory = _t[0], setSelectedCategory = _t[1];
    var _u = useState([]), selectedProduct = _u[0], setSelectedProduct = _u[1];
    // const [initialFormValues, setInitialFormValues] = useState(useForm.values)
    // add identifier to differs between initial values from props and actual formik values
    var _v = useState(false), isAddedNewProduct = _v[0], setIsAddedNewProduct = _v[1];
    var talentOptions = useMemo(function () {
        var _a;
        if (talents === null || talents === void 0 ? void 0 : talents.data) {
            return (_a = talents === null || talents === void 0 ? void 0 : talents.data) === null || _a === void 0 ? void 0 : _a.map(function (talent) {
                var profiles = talent.profiles.map(function (profile) { return profile.profileName; }).join(' / ');
                return {
                    label: "".concat(talent.name, " (").concat(profiles, ")"),
                    value: talent.pubId,
                };
            });
        }
        return [];
    }, [talents === null || talents === void 0 ? void 0 : talents.data]);
    var optionCouriers = (couriers === null || couriers === void 0 ? void 0 : couriers.data) &&
        couriers.data.length > 0 &&
        couriers.data.map(function (courier) { return ({
            label: courier.name,
            value: courier.pubId,
        }); });
    var optionAddresses = addresses &&
        addresses.length > 0 &&
        addresses
            .filter(function (address) { return address.approved; })
            .map(function (address) { return ({
            label: "".concat(address.recipientName, " - ").concat(address.address, ", ").concat(address.city.name),
            value: address.pubId,
        }); });
    var optionProductCategories = productCategory &&
        productCategory.length > 0 &&
        productCategory.map(function (pcategory) { return ({
            label: pcategory.name,
            value: pcategory.pubId,
        }); });
    var onChangeTalent = function (e) {
        setEditId(e.value);
        setSelectedTalent(e);
        useForm.setFieldValue('talentPubId', e.value);
        onChangeJob(undefined);
        onChangeAddress(undefined);
    };
    var onChangeAddress = function (e) {
        setSelectedAddress(e || []);
        useForm.setFieldValue('talentAddressPubId', (e === null || e === void 0 ? void 0 : e.value) || '');
    };
    var onChangeJob = function (e) {
        setSelectedJob(e);
        useForm.setFieldValue('jobPubId', (e === null || e === void 0 ? void 0 : e.value) || '');
        onChangeTeam(undefined);
    };
    var onChangeTeam = function (e) {
        setSelectedTeam(e);
        useForm.setFieldValue('teamPubId', (e === null || e === void 0 ? void 0 : e.value) || '');
    };
    var onChangeCourier = function (e) {
        setSelectedCourier(e);
        useForm.setFieldValue('courierPubId', e.value);
    };
    var handleAdd = function () {
        var newProduct = {
            productPubId: '',
            productCategoryPubId: '',
            qty: 1,
        };
        var productValue = __spreadArray(__spreadArray([], useForm.values.sendProduct.products, true), [newProduct], false);
        useForm.setFieldValue('sendProduct.products', productValue);
        var newItemObject = {
            label: '',
            value: '',
        };
        setSelectedCategory(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [newItemObject], false); });
        setSelectedProduct(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [newItemObject], false); });
        // setEditableValue(useForm.values.sendProduct.products)
        setIsAddedNewProduct(true);
    };
    var handleRemove = function (position) {
        setSelectedProduct(selectedProduct.map(function (p, index) {
            if (position === index) {
                return { label: '', value: '' };
            }
            return p;
        }));
        setSelectedCategory(selectedCategory.map(function (c, index) {
            if (position === index) {
                return { label: '', value: '' };
            }
            return c;
        }));
        useForm.setValues(__assign(__assign({}, useForm.values), { sendProduct: {
                products: useForm.values.sendProduct.products.filter(function (_, index) { return index !== position; }),
            } }));
    };
    var onChangeCategoryList = function (e, position) {
        var updatedCategoryList = selectedCategory.map(function (category, index) {
            if (index === position) {
                return e;
            }
            else {
                return category;
            }
        });
        var updatedProductList = selectedProduct.map(function (p, idx) {
            if (idx === position)
                return { value: '', label: '' };
            return p;
        });
        setSelectedCategory(selectedCategory.length ? updatedCategoryList : [e]);
        setSelectedProduct(updatedProductList);
        setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify([['productCategory.pubId', e.value]]) }));
        useForm.setFieldValue("sendProduct.products[".concat(position, "].productCategoryPubId"), e.value);
    };
    var onChangeProductList = function (e, position) {
        var updatedProductList = selectedProduct.map(function (product, index) {
            if (index === position) {
                return e;
            }
            else {
                return product;
            }
        });
        setSelectedProduct(selectedProduct.length ? updatedProductList : [e]);
        useForm.setFieldValue("sendProduct.products[".concat(position, "].productPubId"), e.value);
    };
    var onLoadProductCategoryList = function () {
        var _a;
        var productCategoryData = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.details) === null || _a === void 0 ? void 0 : _a.map(function (category) {
            var _a, _b, _c, _d;
            return {
                label: ((_b = (_a = category === null || category === void 0 ? void 0 : category.product) === null || _a === void 0 ? void 0 : _a.productCategory) === null || _b === void 0 ? void 0 : _b.name) || '',
                value: ((_d = (_c = category === null || category === void 0 ? void 0 : category.product) === null || _c === void 0 ? void 0 : _c.productCategory) === null || _d === void 0 ? void 0 : _d.pubId) || '',
            };
        });
        setSelectedCategory((currentData === null || currentData === void 0 ? void 0 : currentData.details) ? productCategoryData : []);
    };
    var onLoadProductList = function () {
        var _a;
        var productList = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.details) === null || _a === void 0 ? void 0 : _a.map(function (detail) {
            var _a, _b;
            return {
                label: ((_a = detail === null || detail === void 0 ? void 0 : detail.product) === null || _a === void 0 ? void 0 : _a.name) || '',
                value: ((_b = detail === null || detail === void 0 ? void 0 : detail.product) === null || _b === void 0 ? void 0 : _b.pubId) || '',
            };
        });
        setSelectedProduct((currentData === null || currentData === void 0 ? void 0 : currentData.details) ? productList : []);
    };
    var onLoadCourierData = function () {
        var _a, _b;
        if (couriers) {
            var courierData = couriers === null || couriers === void 0 ? void 0 : couriers.data.find(function (courier) { var _a; return courier.pubId === ((_a = currentData === null || currentData === void 0 ? void 0 : currentData.courier) === null || _a === void 0 ? void 0 : _a.pubId); });
            var data = {
                label: (_a = courierData === null || courierData === void 0 ? void 0 : courierData.name) !== null && _a !== void 0 ? _a : '',
                value: (_b = courierData === null || courierData === void 0 ? void 0 : courierData.pubId) !== null && _b !== void 0 ? _b : '',
            };
            setSelectedCourier(courierData ? [data] : []);
        }
    };
    var onLoadTalentData = function () {
        var _a, _b;
        setSelectedTalent({
            label: (_a = currentData === null || currentData === void 0 ? void 0 : currentData.talent) === null || _a === void 0 ? void 0 : _a.name,
            value: (_b = currentData === null || currentData === void 0 ? void 0 : currentData.talent) === null || _b === void 0 ? void 0 : _b.pubId,
        });
        // useForm.setFieldValue('talentPubId', currentData?.talent?.pubId)
    };
    var onLoadJobTalent = function () {
        var _a, _b;
        if (currentData === null || currentData === void 0 ? void 0 : currentData.job) {
            setSelectedJob({
                label: (_a = currentData === null || currentData === void 0 ? void 0 : currentData.job) === null || _a === void 0 ? void 0 : _a.jobNumber,
                value: (_b = currentData === null || currentData === void 0 ? void 0 : currentData.job) === null || _b === void 0 ? void 0 : _b.pubId,
            });
        }
    };
    var onLoadTeamTalent = function () {
        var _a, _b;
        if (currentData === null || currentData === void 0 ? void 0 : currentData.team) {
            setSelectedTeam({
                label: (_a = currentData === null || currentData === void 0 ? void 0 : currentData.team) === null || _a === void 0 ? void 0 : _a.name,
                value: (_b = currentData === null || currentData === void 0 ? void 0 : currentData.team) === null || _b === void 0 ? void 0 : _b.pubId,
            });
        }
    };
    var onLoadAddressData = function () {
        var _a, _b, _c, _d, _e, _f;
        var data = {
            label: (_d = "".concat((_a = currentData === null || currentData === void 0 ? void 0 : currentData.address) === null || _a === void 0 ? void 0 : _a.recipientName, " - ").concat((_b = currentData === null || currentData === void 0 ? void 0 : currentData.address) === null || _b === void 0 ? void 0 : _b.address, " - ").concat((_c = currentData === null || currentData === void 0 ? void 0 : currentData.address) === null || _c === void 0 ? void 0 : _c.city.name, " ")) !== null && _d !== void 0 ? _d : '',
            value: (_f = (_e = currentData === null || currentData === void 0 ? void 0 : currentData.address) === null || _e === void 0 ? void 0 : _e.pubId) !== null && _f !== void 0 ? _f : '',
        };
        setSelectedAddress((currentData === null || currentData === void 0 ? void 0 : currentData.address) ? [data] : []);
    };
    var _w = useState(false), isMounted = _w[0], setIsMounted = _w[1];
    useEffect(function () {
        if (isMounted)
            return;
        if (currentData && (couriers === null || couriers === void 0 ? void 0 : couriers.data)) {
            onLoadTalentData();
            onLoadJobTalent();
            onLoadTeamTalent();
            onLoadAddressData();
            onLoadCourierData();
            onLoadProductCategoryList();
            onLoadProductList();
            setIsMounted(true);
        }
    }, [currentData, couriers]);
    var _x = useState([]), selectedCityAddress = _x[0], setSelectedCityAddress = _x[1];
    var onChangeCityAddress = function (e) {
        setSelectedCityAddress(e);
        useForm.values.address.cityPubId = e.value;
    };
    var cities = useCities().cities;
    var cityOptions = cities === null || cities === void 0 ? void 0 : cities.data.map(function (city) { return ({
        label: city.name,
        value: city.pubId,
    }); });
    var talentPubId = useForm.values.talentPubId || '';
    var talentJobs = useTalentJob(talentPubId, {
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: "[[\"talent.pubId\", \"".concat(talentPubId, "\"], [\"IsApproved\", true], [\"IsCanceled\", false], [\"IsCompleted\", false]]"),
        initialFilterBy: "[[\"talent.pubId\", \"".concat(talentPubId, "\"],  [\"IsApproved\", true], [\"IsCanceled\", false], [\"IsCompleted\", false]]"),
    }, !!talentPubId).talentJobs;
    var jobOptions = talentJobs === null || talentJobs === void 0 ? void 0 : talentJobs.data.map(function (job) { return ({
        label: job.job.jobNumber,
        value: job.pubId,
    }); });
    var teamOptions = useMemo(function () {
        if (currentData === null || currentData === void 0 ? void 0 : currentData.team) {
            return [
                {
                    label: currentData.team.name,
                    value: currentData.team.pubId,
                },
            ];
        }
        if (selectedJob) {
            var job = talentJobs === null || talentJobs === void 0 ? void 0 : talentJobs.data.find(function (job) {
                return job.pubId === selectedJob.value;
            });
            return job ? [{ label: job.job.team.name, value: job.job.team.pubId }] : [];
        }
        if (selectedTalent) {
            var talent = cachedTalentsData.find(function (talent) {
                return talent.pubId === selectedTalent.value;
            });
            return talent
                ? talent.talentTeams.map(function (team) { return ({
                    label: team.team.name,
                    value: team.team.pubId,
                }); })
                : [];
        }
        return [];
    }, [selectedJob, selectedTalent, cachedTalentsData, currentData]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(MultiSelectFormik, { name: 'talentPubId', label: 'Talent', formik: useForm, isMulti: false, isRequired: true, options: talentOptions, value: selectedTalent ? [selectedTalent] : [], onchange: onChangeTalent, onInputChange: function (value) { return setFilter(function (prev) { return (__assign(__assign({}, prev), { keyword: value })); }); }, isDisabled: location.pathname.includes('job') || !!currentData }) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: jobOptions && (_jsx(MultiSelectFormik, { name: 'jobPubId', label: 'Kerjasama', formik: useForm, isMulti: false, options: jobOptions, value: selectedJob ? [selectedJob] : [], onchange: onChangeJob, clearable: true })) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: teamOptions.length > 0 && (_jsx(MultiSelectFormik, { name: 'teamPubId', label: 'Tim', formik: useForm, isMulti: false, options: teamOptions, value: selectedTeam ? [selectedTeam] : [], onchange: onChangeTeam, isRequired: true, clearable: true })) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: optionCouriers && (_jsx(MultiSelectFormik, { name: 'courierPubId', label: 'Kurir', formik: useForm, isRequired: true, isMulti: false, options: optionCouriers, value: selectedCourier, onchange: onChangeCourier })) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsxs("div", { children: [optionAddresses ? (_jsx(MultiSelectFormik, { name: 'talentAddressPubId', label: 'Alamat', formik: useForm, isMulti: false, isRequired: true, options: __spreadArray(__spreadArray([], defaultOptionAddress, true), optionAddresses, true), value: selectedAddress, onchange: onChangeAddress, isDisabled: location.pathname.includes('job') || (currentData === null || currentData === void 0 ? void 0 : currentData.address.approved) === false })) : (_jsx("div", __assign({ className: 'form-label fs-6 fw-bolder text-dark mb-3', style: { marginTop: '-1rem' } }, { children: editId ? 'Alamat untuk talent ini masih kosong' : 'Anda belum memilih talent' }))), useForm.values.talentAddressPubId === 'add-new' && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Penerima', type: 'text', placeholder: 'Nama Penerima', name: 'address.recipientName', formik: useForm, isRequired: true, errorMessage: (_c = (_b = useForm.errors) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.recipientName }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nomor Penerima', type: 'text', placeholder: 'Nomor Penerima', name: 'address.recipientPhoneNumber', formik: useForm, isRequired: true, errorMessage: (_d = useForm.errors.address) === null || _d === void 0 ? void 0 : _d.recipientPhoneNumber }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Alamat', placeholder: 'Alamat', name: "address.address", formik: useForm, isRequired: true, isChildField: true, errorMessage: (_e = useForm.errors.address) === null || _e === void 0 ? void 0 : _e.address }) })), _jsx("div", __assign({ className: 'my-5' }, { children: cityOptions && (_jsx(MultiSelectFormik, { name: 'address.cityPubId', label: 'Kota/Kabupaten', formik: useForm, isMulti: false, options: cityOptions, value: selectedCityAddress, onchange: onChangeCityAddress, isRequired: true, errorMessage: (_f = useForm.errors.address) === null || _f === void 0 ? void 0 : _f.cityPubId })) }))] }))] }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: 'note', formik: useForm }) }) })), _jsxs("div", __assign({ className: 'mb-5 py-3' }, { children: [_jsx("div", __assign({ className: 'float-start' }, { children: _jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "List Barang" })) })), _jsx("div", __assign({ className: 'float-end mb-3' }, { children: _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success', onClick: handleAdd }, { children: "Tambah Barang" })) }))] })), _jsx("div", __assign({ className: 'mt-15 d-flex' }, { children: _jsx("div", __assign({ className: 'float-start' }, { children: _jsx(_Fragment, { children: (_j = (_h = (_g = useForm.values) === null || _g === void 0 ? void 0 : _g.sendProduct) === null || _h === void 0 ? void 0 : _h.products) === null || _j === void 0 ? void 0 : _j.map(function (categories, index) { return (_jsx(ProductForm, { useForm: useForm, index: index, productCategoryList: optionProductCategories, removeProduct: handleRemove, onchangecategory: onChangeCategoryList, onchangeproduct: onChangeProductList, selectedcategory: selectedCategory[index] || undefined, selectedproduct: selectedProduct[index] || undefined, handleBlur: function () { }, name: 'sendProduct.products' }, index)); }) }) })) })), role === RoleList.Reqsi && location.pathname.includes('job') && (_jsx("div", __assign({ className: 'mt-5' }, { children: _jsx(FileFormik, { label: 'Bukti Transfer', placeholder: 'Bukti Transfer', name: 'buktiTransfer', formik: useForm, onChange: function () { } }) })))] }));
};
export default memo(SendProductForm);
